@if (project) {
<div class="flex flex-col items-center w-full px-4 sm:px-6 md:px-20 space-y-6 pt-[100px] select-none">

  <img [src]="project.logo" alt="{{project.name}}"
    class="w-[120px] sm:w-[150px] md:w-[200px] h-auto rounded-[25px] object-contain">

  <h2 class="text-2xl sm:text-3xl md:text-4xl font-bold text-center break-words">
    {{ project.name }}
  </h2>

  <p class="text-sm sm:text-base md:text-lg text-center max-w-full sm:max-w-2xl md:max-w-4xl lg:max-w-5xl break-words">
    {{ project.description }}
  </p>

  <div class="relative w-full">

    <div #carousel
      class="carousel w-full overflow-x-auto scrollbar-hide scroll-smooth cursor-grab active:cursor-grabbing select-none"
      (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerUp($event)" (click)="onCarouselClick($event)">
      <div class="flex flex-row items-center gap-4 sm:gap-5 md:gap-6 px-4 py-2 flex-nowrap select-none">
        @for (img of project.images; track $index) {
        <div class="flex-none select-none px-1 sm:px-2 md:px-3">
          <img [src]="img" alt="Project image"
            class="w-[250px] sm:w-[280px] md:w-[300px] h-auto object-contain rounded-md flex-none select-none" />
        </div>
        }
      </div>
    </div>

  </div>

</div>

<app-dynamic-numbered-card [items]="project.dynamicContent"></app-dynamic-numbered-card>
}